import PostListComponent from '../../postAdmin/PostListComponent';

const PostsCustomer = ({ routeBase = "/customer/posts" }) => {
  return <PostListComponent route={routeBase} />;
};

export default PostsCustomer;
